import { render, staticRenderFns } from "./Cargos.vue?vue&type=template&id=50d57002&scoped=true"
import script from "./Cargos.vue?vue&type=script&lang=js"
export * from "./Cargos.vue?vue&type=script&lang=js"
import style0 from "./Cargos.vue?vue&type=style&index=0&id=50d57002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d57002",
  null
  
)

export default component.exports